export default "__VITE_ASSET__cff70866__"